import { cycleCountApi } from "./cycleCount";

export const { useGetIncompleteCycleCountsQuery } = cycleCountApi;
